import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Picture } from '@app/core/models';

@Injectable()
export class UploadService extends ApiService {
  constructor(private http: HttpClient) {
    super();
  }

  uploadPicture(data: any): Observable<Picture> {
    const url = this.pathUrl.uploadPictures(this.userUuid());
    const formData: FormData = new FormData();
    formData.append('file', data);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'multipart/form-data');

    return this.http.post(url, formData, { headers: headers }).pipe(
      map((result) => result),
      catchError(this.handleError.bind(this))
    );
  }
}
